import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GetActiveMenuName } from '../../utilities';

const Overlay = styled.div`
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
`;

class ModalOverlay extends PureComponent {
  static propTypes = {
    contentRef: PropTypes.shape({}).isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  constructor(props) {
    super(props);

    this.initialClientY = -1;
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.isOnSearchPage = false;
  }

  componentDidMount() {
    this.isOnSearchPage = GetActiveMenuName() === 'cars';
    if (!this.isOnSearchPage) {
      this.disableBodyScrolling();
    }
  }

  componentWillUnmount() {
    if (!this.isOnSearchPage) {
      this.enableBodyScrolling();
    }
  }

  disableBodyScrolling() {
    this.bodyOverflow = document.body.style.overflow;
    this.documentOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  enableBodyScrolling() {
    document.body.style.overflow = this.bodyOverflow || '';
    document.documentElement.style.overflow = this.documentOverflow || '';
  }

  handleTouchStart(event) {
    const hasTargetElements = event.targetTouches.length === 1;
    if (hasTargetElements) {
      this.initialClientY = event.targetTouches[0].clientY;
    }
  }

  handleTouchMove(event) {
    const { contentRef } = this.props;
    const isTargetElementTotallyScrolled = (
      contentRef.scrollHeight - contentRef.scrollTop) <= contentRef.clientHeight;
    const clientY = event.targetTouches[0].clientY - this.initialClientY;
    const shouldDisableScrollingUp = contentRef.scrollTop === 0 && clientY > 0;
    const shouldDisableScrollingDown = isTargetElementTotallyScrolled && clientY < 0;

    const shouldPreventElementScroll = (
      event.target !== contentRef && !contentRef.contains(event.target))
      || shouldDisableScrollingUp
      || shouldDisableScrollingDown;

    if (shouldPreventElementScroll) {
      event.preventDefault();
      event.stopPropogation();
    }
  }

  render() {
    const { onClick } = this.props;
    return (
      <Overlay
        onClick={onClick}
        touchMove={!this.isOnSearchPage && this.handleTouchMove}
        touchStart={!this.isOnSearchPage && this.handleTouchStart}
      />
    );
  }
}

export default ModalOverlay;
